export default __webpack_public_path__ + "static/media/shape-11.e6fbfdb5.svg";